import Vue from 'vue'
import { router } from '@src/routes'
import { LEAD_STATUS } from '@modules/leads/domain/data/lead.status.data'

const isProd = process.env.NODE_ENV === 'production'

const SUCCESS = { success: true }
const ERROR = { success: false }

/**
 * модуль для ВСЕХ методов связанных с лидами
 *
 * выгрузка страниц lk/leads и lk/leads/view
 * стейт только для страницы lk/leads
 * для страницы отдельного лида достаточно использовать состояние компонента
 *
 *
 */
export default {
  namespaced: true,
  state: {
    linkOffer: null,
    isFirst: false,
    optionsRequest: [],
    linkFaqLeads: null,
    rating: 0,
    reasons: [],
    footerTable: '',
    filter: null,
    pagination: null,
    leadsExpired: [],
    leadExpiredCount: 0,
    leadsCompleted: [],
    leads: [],
    leadsFilter: null,
    productionCalendar: [],
  },
  getters: {
    getNewLeads(state) {
      return state.leads.filter(el => el.status === 0)
    },
    getWorkLeads(state) {
      return state.leads.filter(el => el.status !== 0)
    },
    getRating(state) {
      return state.rating
    },
    getReasons(state) {
      return state.reasons
    },
    productionCalendar(state) {
      if (!state.productionCalendar || !Array.isArray(state.productionCalendar)) return {}

      return state.productionCalendar.reduce((resAccDates, item) => {
        const yearAndMonth = item?.monthDate?.dym

        item?.monthReference?.forEach(day => {
          resAccDates[`${yearAndMonth}-${String(day).padStart(2, '0')}`] = true
        })

        return resAccDates
      }, {})
    },
  },
  mutations: {
    setData(state, newData) {
      state.linkOffer = newData.linkOffer
      state.isFirst = newData.isFirst
      state.optionsRequest = newData.optionsRequest
      state.linkFaqLeads = newData.linkFaqLeads
      state.leadsFilter = newData.leadsFilter
      state.leadsExpired = newData.leadsExpired
      state.leadExpiredCount = newData.leadExpiredCount
      state.rating = newData.rating
      state.reasons = newData.reasons
      state.footerTable = newData.footerTable
      state.filter = newData.filter
      state.leads = newData.leads
      state.leadsCompleted = newData.leadsCompleted
      state.pagination = newData.pagination
      state.productionCalendar = newData.productionCalendar
    },
    setIsFirst(state, newValue) {
      state.isFirst = newValue
    },
    setItemLead(state, data) {
      const index = state.leads.map(el => el.id).indexOf(data.id)
      state.leads[index][data.name] = data.value
      if (data.name == 'status' && data.value == 2) {
        Vue.set(state.leads[index], 'noConfirm', true)
      }
    },
    // перенес мутацию без изменений
    // для чего нужно хз
    // TODO: узнать и зарефакторить
    setItemLeadTimer(state, data) {
      const item = state.leads.find(el => el.id === data.id)
      item.timer[data.name] = data.value
    },
  },
  actions: {
    // открываем модалку из этого стора через диспатч
    // экономим время и кучу места
    openErrorModal({ dispatch }, data) {
      let text = window.staticText.lk.lkErrorText
      if (data.errors && data.errors.length > 0) {
        let key = Object.keys(data.errors)[0]
        if (data.errors[key][0]) {
          text = data.errors[key][0]
        }
      }

      dispatch(
        'modal/modalType_lkErrorOpen',
        {
          title: window.staticText.lk.lkErrorTitle,
          text: text,
          closeBthNone: true,
        },
        { root: true }
      )
    },
    // по такому же принципу открываем модалку успеха
    openSuccessModal({ dispatch }) {
      dispatch(
        'modal/modalType_lkSuccessOpen',
        {
          title: window.staticText.lk.successTitle,
          closeBthNone: true,
        },
        { root: true }
      )
    },
    openWinLeadModal({ dispatch }, props) {
      dispatch('modal/modalType_lkWinLeadModalOpen', { ...props, title: window.staticText.lk.successTitle }, { root: true })
    },
    // страница лидов
    // поидее можно params вытаскивать прямо здесь через router.currentRoute
    // как в экшене получения одной страницы лида
    async getLeadsPage({ commit }, params) {
      const url = isProd ? 'lk/leads' : 'lk/leadsPage.json'

      try {
        const { data } = await Vue.http.get(url, { params })

        commit('setData', data)
      } catch (error) {
        switch (error.status) {
          case 403:
            router.push({ name: 'E403' })
            break
          default:
            router.push({ name: 'E404' })
            break
        }
      }
    },
    async getLeadPage() {
      const params = router.currentRoute.query

      const url = isProd ? router.currentRoute.path.substring(1).replace(router.history.base, '') : 'lk/leadsViewPage.json'

      try {
        const { data } = await Vue.http.get(url, { params })
        return { data }
      } catch (error) {
        switch (error.status) {
          case 403:
            router.push({ name: 'E403' })
            break
          default:
            router.push({ name: 'E404' })
            break
        }
      }
    },
    async requestSecondStep({ dispatch, commit }) {
      const url = isProd ? 'lk/leads/toSecondStep' : 'lk/leadsPage.json'
      const method = isProd ? 'post' : 'get'

      try {
        const { data } = await Vue.http[method](url)
        if (!data.success) throw data

        commit('setIsFirst', false)
        return SUCCESS
      } catch (data) {
        dispatch('openErrorModal', data)
        return ERROR
      }
    },
    async acceptLead({ dispatch }, id) {
      const url = isProd ? 'lk/leads/accept' : 'lk/leadsPage.json'

      const method = isProd ? 'post' : 'get'

      const formData = new FormData()
      formData.append('leadId', id)

      try {
        const { data } = await Vue.http[method](url, formData)
        if (!data.success) throw data

        dispatch('openSuccessModal')
        return SUCCESS
      } catch (data) {
        dispatch('openErrorModal', data)
        return ERROR
      }
    },
    async closeLead({ dispatch }, { id }) {
      const url = isProd ? 'lk/leads/closed' : 'lk/leadsPage.json'

      const method = isProd ? 'post' : 'get'

      const formData = new FormData()
      formData.append('leadId', id)

      try {
        const { data } = await Vue.http[method](url, formData)
        if (!data.success) throw data

        dispatch('openSuccessModal')
        return SUCCESS
      } catch (data) {
        dispatch('openErrorModal', data)
        return ERROR
      }
    },
    async refuseLead({ dispatch }, { id, reasonId, comment }) {
      const url = isProd ? 'lk/leads/refuse' : 'lk/leadsPage.json'

      const method = isProd ? 'post' : 'get'

      const formData = new FormData()
      formData.append('leadId', id)
      if (reasonId) formData.append('reasonId', reasonId)
      if (comment) formData.append('comment', comment)

      try {
        const { data } = await Vue.http[method](url, formData)
        if (!data.success) throw data

        dispatch('openSuccessModal')
        return SUCCESS
      } catch (data) {
        dispatch('openErrorModal', data)
        return ERROR
      }
    },
    async changeStatus({ dispatch }, data) {
      const url = isProd ? 'lk/leads/changeStatus' : 'lk/leadsPage.json'
      const method = isProd ? 'post' : 'get'

      const formData = new FormData()

      formData.append('leadId', data.id)
      formData.append('status', data.status)
      if (data.status === LEAD_STATUS.WON) {
        formData.append('date', data.date)
        formData.append('amount', data.amount)
        formData.append('invoiceNumber', data.invoiceNumber)
        formData.append('dealResult', data.dealResult)
        formData.append('relationshipDeveloped', data.relationshipDeveloped)
        formData.append('dealComment', data.dealComment)
      }

      try {
        const { data } = await Vue.http[method](url, formData)
        if (!data.success) throw data

        dispatch('openSuccessModal')
        return SUCCESS
      } catch (e) {
        dispatch('openErrorModal', e)
        return ERROR
      }
    },
    async changeDate({ dispatch }, { id, date, comment }) {
      const url = isProd ? 'lk/leads/changeDate' : 'lk/leadsPage.json'
      const method = isProd ? 'post' : 'get'

      const formData = new FormData()
      formData.append('leadId', id)
      formData.append('date', date)
      // теперь коментарий должен быть всегда
      formData.append('comment', comment)

      console.debug(...formData)

      try {
        const { data } = await Vue.http[method](url, formData)
        if (!data.success) throw data

        dispatch('openSuccessModal')
        return SUCCESS
      } catch (data) {
        dispatch('openErrorModal', data)
        return ERROR
      }
    },
    async addContact({ dispatch }, { id, contactId }) {
      const url = isProd ? 'lk/leads/addContact' : 'lk/leadsPage.json'
      const method = isProd ? 'post' : 'get'

      const formData = new FormData()
      formData.append('leadId', id)
      formData.append('contactId', contactId)

      try {
        const { data } = await Vue.http[method](url, formData)

        if (!data.success) throw data

        dispatch('openSuccessModal')
        return SUCCESS
      } catch (data) {
        dispatch('openErrorModal', data)
      }
    },
  },
}



// WEBPACK FOOTER //
// ./src/legacy/store/modules/lk-leads.js